import type { Identifier, ListParams, ProviderOpportunityParams } from './types';

export const manproQueryKeys = {
  taxonomy: () => ['manpro', 'taxonomy'] as const,
  ownerProjects: (params?: ListParams) =>
    ['manpro', 'owner', 'projects', params ?? {}] as const,
  ownerProjectsSummary: () =>
    ['manpro', 'owner', 'projects', 'summary'] as const,
  ownerProject: (id: Identifier) =>
    ['manpro', 'owner', 'projects', String(id)] as const,
  ownerProjectBids: (projectId: Identifier, params?: ListParams) =>
    ['manpro', 'owner', 'projects', String(projectId), 'bids', params ?? {}] as const,
  ownerProjectBid: (projectId: Identifier, bidId: Identifier) =>
    ['manpro', 'owner', 'projects', String(projectId), 'bids', String(bidId)] as const,
  ownerAllBids: (params?: ListParams) =>
    ['manpro', 'owner', 'bids', 'all', params ?? {}] as const,
  ownerBidsSummary: () =>
    ['manpro', 'owner', 'bids', 'summary'] as const,
  ownerMonitoring: (projectId: Identifier) =>
    ['manpro', 'owner', 'projects', String(projectId), 'monitoring'] as const,
  ownerOpportunities: (params?: ProviderOpportunityParams) =>
    ['manpro', 'owner', 'opportunities', params ?? {}] as const,
  ownerOpportunity: (id: Identifier) =>
    ['manpro', 'owner', 'opportunities', String(id)] as const,
  ownerReports: (projectId: Identifier) =>
    ['manpro', 'owner', 'projects', String(projectId), 'reports'] as const,
  ownerDocuments: (projectId: Identifier) =>
    ['manpro', 'owner', 'projects', String(projectId), 'documents'] as const,
  ownerApprovals: (projectId: Identifier) =>
    ['manpro', 'owner', 'projects', String(projectId), 'approvals'] as const,
  providerOpportunities: (params?: ProviderOpportunityParams) =>
    ['manpro', 'provider', 'opportunities', params ?? {}] as const,
  providerOpportunity: (id: Identifier) =>
    ['manpro', 'provider', 'opportunities', String(id)] as const,
  providerOpportunityFavorites: () =>
    ['manpro', 'provider', 'opportunities', 'favorites'] as const,
  providerBids: (params?: ListParams) =>
    ['manpro', 'provider', 'bids', params ?? {}] as const,
  providerBid: (bidId: Identifier) =>
    ['manpro', 'provider', 'bids', String(bidId)] as const,
  providerProjects: (params?: ListParams) =>
    ['manpro', 'provider', 'projects', params ?? {}] as const,
  providerProject: (projectId: Identifier) =>
    ['manpro', 'provider', 'projects', String(projectId)] as const,
};
